import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ok-play-page',
  templateUrl: './ok-play-page.component.html',
  styleUrls: ['./ok-play-page.component.scss'],
})
export class OkPlayPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
